module.exports = __webpack_public_path__ + "static/media/hanley_economic.cb688434.jpg";